import React, { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import SCDropdown from "./form/dropdown/SCDropdown";

type Props = any;

const SelectFormaPagamento: React.FC<Props> = ({
  name,
  control,
  errors,
  label,
  loading,
  minLength = 3,
  ...props
}) => {
  const [lista, setLista] = useState<any>([]);

  useEffect(() => {
    const loadFormasPagamento = async () => {
      try {
        const resultFormasPag = await api.get("/formasPagamento/combo");
        if (resultFormasPag.data) {
          const filteredFormasPag = resultFormasPag.data.filter(
            (item: any) => item.Tipo != "4" && item.ExibirAPagar == true
          );
          setLista(filteredFormasPag);
        } else {
          setLista([]);
        }
      } catch (error) {
        console.error("Erro ao carregar as Formas de Pagamento:", error);
        setLista([]);
      }
    };

    loadFormasPagamento();
  }, []);

  return (
    <SCDropdown
      control={control}
      errors={errors}
      name="FormasPagamentoId"
      label="Forma de Pagamento"
      options={lista}
      optionLabel="Descricao"
      optionValue="FormasPagamentoId"
      filter={false}
      {...props}
    />
  );
};

export default SelectFormaPagamento;
